import { RecordingTitleSearchItem } from "../model/search";
import axios from "axios";
import "../helpers/axios";

const API_BASE_URL = process.env.REACT_APP_API_URL ?? "";

const buildUrl = (path: string): string => `${API_BASE_URL}${path}`;

type SearchEnvelope = {
  data?: RecordingTitleSearchItem[];
  message?: string;
};

const normalize = (value: string): string => value.trim().toLowerCase();

export const searchRecordingTitles = async (
  query: string,
  options?: { category?: string },
): Promise<RecordingTitleSearchItem[]> => {
  const normalized = normalize(query);
  if (!normalized) {
    return [];
  }

  const response = await axios.get<SearchEnvelope>(
    buildUrl("/recordings/search"),
    {
      params: {
        q: normalized,
        category: options?.category,
      },
    },
  );

  return Array.isArray(response.data?.data) ? response.data.data : [];
};

export const fakeSearchRecordingTitles = searchRecordingTitles;
